import React from 'react';
import PropTypes from 'prop-types';
import {
  Flex,
  IconButton,
  Typography,
} from '@knockrentals/knock-shared-web-v2';
import SocialUrl from './SocialUrl';

export const DELETE_LINK_LABEL = 'delete custom link';
export const EDIT_LINK_LABEL = 'edit custom link';

const CustomLinks = ({
  customLinks,
  handleDeleteCustomLinkOnClick,
  openCustomLinkDialog,
}) => {
  return (
    <Flex flexDirection="column" gap={8} flex={1}>
      <Typography color="text.tertiary" variant="overline2">
        other media links
      </Typography>

      {customLinks.map((link, index) => {
        return (
          <SocialUrl
            endIcon={
              <IconButton
                aria-label={DELETE_LINK_LABEL}
                iconName="trash-bin"
                color="destructive"
                onClick={handleDeleteCustomLinkOnClick(index)}
              />
            }
            id={`custom-link-${index}`}
            key={`${link.title}${link.url}`}
            label={link.title}
            readOnly
            startIcon={
              <IconButton
                aria-label={EDIT_LINK_LABEL}
                iconName="link"
                onClick={openCustomLinkDialog(index)}
              />
            }
            value={link.url}
          />
        );
      })}
    </Flex>
  );
};

CustomLinks.propTypes = {
  customLinks: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
  handleDeleteCustomLinkOnClick: PropTypes.func,
  openCustomLinkDialog: PropTypes.func,
};

export default CustomLinks;
